/**
 * Created by richardlovejoy on 2/16/17.
 */
import Logger from 'js-logger';
import _ from 'underscore';

import {MachineConstants as mc} from '../constants/MachineConstants';

import Ball from './Ball';
import GameSounds from '../sound/GameSounds';

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const BallDispenser = function(game, ballCreateOptions) {

  Phaser.Group.call(this, game);
  this.name = "BallDispenser";

  this.init(ballCreateOptions);
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////

BallDispenser.RAMP_VEC = {
  x: 0,
  y: Math.sin(mc.FRONT_RAMP_SLOPE),
  z: -Math.cos(mc.FRONT_RAMP_SLOPE)
};

BallDispenser.STATE_IDLE = 0;
BallDispenser.STATE_DISPENSING = 1;

BallDispenser.BALL_POOL_SIZE = 15;
BallDispenser.BALL_SPACING = mc.BALL_RADIUS*2;

BallDispenser.DISPENSER_START_BALL_PLACEMENT = {
  x: mc.DISPENSER_END_BALL_PLACEMENT.x,
  y: mc.DISPENSER_END_BALL_PLACEMENT.y + BallDispenser.RAMP_VEC.y * mc.DISPENSER_START_BALL_PLACEMENT_DISTANCE,
  z: mc.DISPENSER_END_BALL_PLACEMENT.z + BallDispenser.RAMP_VEC.z * mc.DISPENSER_START_BALL_PLACEMENT_DISTANCE
};

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
BallDispenser.prototype = _.extend( Object.create( Phaser.Group.prototype ), {

  constructor: BallDispenser,


  init(ballCreateOptions) {

    this.state = BallDispenser.STATE_IDLE;
    this.balls = [];

    // underside
    this.backing = this.game.add.image(0, 0, 'skee', 'ballTrayBack.png', this);

    // create the pool of visual balls
    for (var i = 0; i < BallDispenser.BALL_POOL_SIZE; i++) {

      var newBall = new Ball(this.game, ballCreateOptions);
      this.add(newBall);
      this.balls.unshift(newBall);
    }

    // signal
    this.onSignalDispensingComplete = new Phaser.Signal();

    return this;
  },

  frameUpdate(dt) {

    this.balls.forEach(ball => ball.frameUpdate(dt));

    // check for state change
    if (this.state === BallDispenser.STATE_DISPENSING) {

      if (!_.some(this.balls, ball => ball.dispensing())) {

        this.state = BallDispenser.STATE_IDLE;
        this.onSignalDispensingComplete.dispatch();

      }
    }


  },

  reset() {

  },

  renderBalls() {

    this.balls.forEach(ball => ball.render());
  },

  addBalls(newBallCollection) {

    if (newBallCollection.length === 0)
      return;

    // check that we have enough balls
    let i = 0;
    while (i < this.balls.length && this.balls[i].inUse()) {
      i++;
    }

    const n = newBallCollection.length;
    const ballsAvailable = this.balls.length-i;
    if (n > ballsAvailable) {
      Logger.error('BallDispenser: not enough balls available!');
      return;
    }

    // get balls from the pool and put them in the dispenser
    let firstUnusedBall = i;
    let dispenseDelay = 0;

    // start+end position
    const rampVec = BallDispenser.RAMP_VEC;
    const restingPosition = Object.assign({}, mc.DISPENSER_END_BALL_PLACEMENT);
    const startPosition = {x: restingPosition.x, y: restingPosition.y+BallDispenser.RAMP_VEC.y*mc.DISPENSER_START_BALL_PLACEMENT_DISTANCE, z: restingPosition.z+BallDispenser.RAMP_VEC.z*mc.DISPENSER_START_BALL_PLACEMENT_DISTANCE};

    // update first rest position
    if (firstUnusedBall > 0) {
      var nextBallRestPos = this.balls[firstUnusedBall-1].dispenseRestPosition;
      restingPosition.y = nextBallRestPos.y + BallDispenser.BALL_SPACING * rampVec.y;
      restingPosition.z = nextBallRestPos.z + BallDispenser.BALL_SPACING * rampVec.z;
    }

    // setup each ball
    newBallCollection.forEach(ballAttributes => {

      // grab a ball from the pool
      var ball = this.balls[firstUnusedBall++];
      ball.dispense(ballAttributes, startPosition, restingPosition, dispenseDelay);

      // update delay
      dispenseDelay += 0.25; // seconds

      // update rest position
      restingPosition.y += BallDispenser.BALL_SPACING * rampVec.y;
      restingPosition.z += BallDispenser.BALL_SPACING * rampVec.z;

    });

    this.state = BallDispenser.STATE_DISPENSING;

    // play tray fill sound
    this.game.soundManager.playSound((n > 4) ? GameSounds.SOUND_BALL_HOPPER : GameSounds.SOUND_TRAY_FILL);

  },

  grabBall() {

    // return the first ball... it must be idle
    if (this.balls.length > 0 && this.balls[0].idle()) {

      // remove it from the array
      var newBall = this.balls.shift();

      // remove it from the group
      this.remove(newBall);

      // shift other balls down
      let dispenseDelay = 0;

      // start+end position
      const restingPosition = Object.assign({}, mc.DISPENSER_END_BALL_PLACEMENT);

      // setup each ball
      this.balls.filter(ball => ball.inDispenser()).forEach(ball => {

        // grab a ball from the pool
        ball.bumpDown(restingPosition, dispenseDelay);

        // update delay
        dispenseDelay += 0.5; // seconds

        // update rest position
        restingPosition.y += BallDispenser.BALL_SPACING * BallDispenser.RAMP_VEC.y;
        restingPosition.z += BallDispenser.BALL_SPACING * BallDispenser.RAMP_VEC.z;

      });

      return newBall;
    }

    return null;
  },

  returnBall(ball) {

    // add to end
    this.balls.push(ball);

    // place ball at 1 depth (behind other balls, on top of backing)
    this.addAt(ball, 1);


  }


});

export default BallDispenser;



// WEBPACK FOOTER //
// ./app/src/display/BallDispenser.js